import * as React from 'react';

import Rive from '@rive-app/react-canvas';

import {Body} from 'shells/typography/body';

import {ANIMATION_SRC} from '../consts';

import {ChatOnboardingLayout} from './chat-onboarding-layout';

type Props = {
    domain: string;
};

export function CrawlingState(props: Props) {
    return (
        <ChatOnboardingLayout
            title='Awesome!'
            subtitle={
                <>
                    Hang tight and give us a few seconds, while we crawl{' '}
                    <Body isBold={true} color='dark'>
                        {props.domain}…
                    </Body>
                </>
            }
            animation={<Rive src={ANIMATION_SRC.CRAWLING_STATE} />}
        />
    );
}
